import {withStyles} from "@material-ui/styles";
import Checkbox from "@material-ui/core/Checkbox";
import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";

export const GreenCheckbox = withStyles({
    root: {
        '&$checked': {
            color: "#00b74a",
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);


export const FormControl = withStyles({
    root: {
        height: "100%",
        marginLeft: "-8px",
        marginRight: 0,
    },
    label: {
        fontSize: "14px",
    }
})((props) => <FormControlLabel {...props}/>);
